import React, { createContext, Dispatch, useContext, useMemo, useReducer } from 'react';
import { appReducer } from './appReducer';
import { ApplicationState, getDefaultInitialApplicationState } from './ApplicationState';

export enum ActionType {
    // eslint-disable-next-line no-unused-vars, max-len
    INITIALISE_TRANSACTION, UPDATE_PERSONAL_DETAILS_ACTION, UPDATE_CONTACT_DETAILS_ACTION, UPDATE_BANK_DETAILS_ACTION, UPDATE_REVIEW_ACTION, UPDATE_SUPPORTING_DOCUMENTS_ACTION, UPDATE_ELIGIBILITY_ACTION, UPDATE_OTHER_DATA
}

export interface AppAction {
    type: ActionType,
    payload: Partial<ApplicationState>
}

export const ApplicationContext = createContext<{
    globalState: ApplicationState,
    dispatch: Dispatch<AppAction>}>({
        globalState: getDefaultInitialApplicationState(),
        dispatch: () => {}
    });
export const useApplicationContext = () => useContext(ApplicationContext);

export const ApplicationContextProvider = ({ children, initialState }) => {
    const [globalState, dispatch] = useReducer(appReducer, initialState ?? getDefaultInitialApplicationState());
    const value = useMemo(() => ({ globalState, dispatch }), [globalState]);
    return (
        <ApplicationContext.Provider value={ value }> { children } </ApplicationContext.Provider>
    );
};
